import React from 'react'

import ScoreGridView from '@components/myScores/ScoresView/ScoreGridView'
import ScoreListView from '@components/myScores/ScoresView/ScoreListView'
import { ScoreViewOptions } from '@components/myScores/utils/types'
import Product from '@models/Product'
import Score from '@models/Score'
import { ViewType } from '@utils/global'

interface Props {
  scores: (Score | Product)[]
  viewType: ViewType
  options?: ScoreViewOptions
}
const ScoresView: React.FC<Props> = ({ scores, viewType, options }) => {
  if (viewType === ViewType.GRID) {
    return <ScoreGridView scores={scores} options={options} />
  }

  if (viewType === ViewType.LIST) {
    return <ScoreListView scores={scores} options={options} />
  }

  console.warn(`Unsupported view type: ${viewType}`)
  return null
}

export default ScoresView
